import { render } from "./component_icon_checkBox.vue?vue&type=template&id=fcf37372"
import script from "./component_icon_checkBox.vue?vue&type=script&lang=js"
export * from "./component_icon_checkBox.vue?vue&type=script&lang=js"

import "./component_icon_checkBox.vue?vue&type=style&index=0&id=fcf37372&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__